import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { RIDE_TYPES } from "@/lib/rides";

export const CUTOFF_HOURS = 6;
export const CLOSED_MSG = "Your modification window has closed. Please contact Scoopz Admin for assistance.";
export const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const EDITABLE = ["pending", "confirmed", "assigned"];

export const cutoffAt = (r, h = CUTOFF_HOURS) => (r.scheduled_at ? new Date(new Date(r.scheduled_at).getTime() - h * 3600000) : null);
export const canModify = (r, h) => EDITABLE.includes(r.status) && !!r.scheduled_at && cutoffAt(r, h) > new Date();
export const isEditableStatus = (r) => EDITABLE.includes(r.status);

export const bucket = (r) => {
  if (["en_route", "arrived", "in_progress"].includes(r.status)) return "active";
  if (r.status === "completed") return "completed";
  if (["cancelled", "declined"].includes(r.status)) return "cancelled";
  return "upcoming";
};

export const typeLabel = (r) => {
  if (r.split_id) return `Split Trip · Leg ${r.split_leg} of 2`;
  const base = RIDE_TYPES[r.trip_type] || "Ride";
  return r.series_id ? `${base} · Recurring ${r.occurrence_index}/${r.occurrence_count}` : base;
};

export const dayTime = (iso) => {
  if (!iso) return { day: "", time: "" };
  const d = new Date(iso);
  return {
    day: d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" }),
    time: d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }),
  };
};

export const useMyRides = () =>
  useQuery({ queryKey: ["myRides", "rider"], queryFn: () => api.get("/rides").then((r) => r.data), refetchInterval: 15000 });

export const useSeries = () => useQuery({ queryKey: ["mySeries"], queryFn: () => api.get("/rides/series").then((r) => r.data), refetchInterval: 30000 });

export const useMyProfile = () => useQuery({ queryKey: ["myProfile"], queryFn: () => api.get("/me/profile").then((r) => r.data) });

export const upcomingRides = (rides = []) =>
  rides.filter((r) => bucket(r) === "upcoming" && r.status !== "paused" && new Date(r.scheduled_at) > new Date())
    .sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
